import React from 'react';
import styled from "styled-components";
import { motion } from "framer-motion";


const Footer = () =>{
    return(
        <Foot>
           
        </Foot>
    );
}

export default Footer;

const Foot = styled(motion.div)`
    min-height: 5vh;
    /* background-color: #6C6CC1; */
`